<template>
<div class="wl-project-intro-wrapper">
    <div class="intro-head-con">
        <router-link v-for="item in certifycateList" :key="item.id" :to="{name:'introMain',params:{certifyId:item.id}}">{{item.titleName}}</router-link>
    </div>
    <div class="intro-container-con">
        <router-view></router-view>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            certifycateList: []
        }
    },
    created() {
        this.getCerfitycateList();
    },
    methods: {
        getCerfitycateList() {
            this.$http.post("/api/XOrg/AssociationIndex/getCertificateList").then(res => {
                if (res.code > 0) {
                    this.certifycateList = res.list;
                    this.certifycateList.forEach(val => {
                        if (val.CertificateName.includes('职业')) {
                            this.$set(val, 'titleName', val.CertificateName.split('职业')[0]);
                        } else {
                            this.$set(val, 'titleName', '');
                        }
                    });
                }
            });
        },
    }
}
</script>

<style lang="scss">
.wl-project-intro-wrapper {
    .intro-head-con {
        margin: 0 auto 40px;
        width: 1200px;
        text-align: center;
        border-bottom: 2px solid #E4E7ED;

        a {
            margin: 0 20px -2px;
            display: inline-block;
            color: #333;
            font-size: 23px;
            height: 40px;
            line-height: 40px;
        }

        .linkActive {
            color: #2D82FF;
            border-bottom: 2px solid #2D82FF;
        }
    }
}

@media only screen and (max-width:960px) {
    .wl-project-intro-wrapper {
        .intro-head-con {
            margin: 0 auto;
            width: 100%;
            text-align: center;

            a {
                height: 32px;
                line-height: 32px;
                font-size: 14px;
            }
        }
    }
}
</style>
